import '../types.mjs';
import { isFunction } from '@vue/shared';
const composeRefs = function () {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
    refs[_key] = arguments[_key];
  }
  return el => {
    refs.forEach(ref => {
      if (isFunction(ref)) {
        ref(el);
      } else {
        ref.value = el;
      }
    });
  };
};
export { composeRefs };